import { TranslateService } from '@ngx-translate/core';

/** Community that should use "entradas" wording instead of "tiques/tickets". */
export const TICKETS_AS_ENTRADAS_COMMUNITY = 'iii-congres-catalunya-circular';

export function usesEntradasWording(communityCode: string | null | undefined): boolean {
  return communityCode === TICKETS_AS_ENTRADAS_COMMUNITY;
}

/** Resolves TICKETS.* vs TICKETS.ENTRADAS.* for the given community. */
export function ticketI18nKey(communityCode: string | null | undefined, key: string): string {
  return usesEntradasWording(communityCode)
    ? `TICKETS.ENTRADAS.${key}`
    : `TICKETS.${key}`;
}

export function ticketingExceededI18nKey(communityCode: string | null | undefined): string {
  return usesEntradasWording(communityCode)
    ? 'Modules.Ticketing.ExceededEntradas'
    : 'Modules.Ticketing.Exceeded';
}

export function ticketingNameI18nKey(communityCode: string | null | undefined): string {
  return usesEntradasWording(communityCode)
    ? 'TICKETING.NameEntradas'
    : 'TICKETING.Name';
}

export function ticketingNoTicketsI18nKey(communityCode: string | null | undefined): string {
  return usesEntradasWording(communityCode)
    ? 'TICKETING.No_TicketsEntradas'
    : 'TICKETING.No_Tickets';
}

export function getTicketMaxByUserExceededMessageParams(
  translate: TranslateService,
  value: number,
  communityCode?: string | null,
): { value: number; ticketWord: string } {
  const ticketWordKey = value === 1
    ? ticketI18nKey(communityCode, 'TicketWordSingular')
    : ticketI18nKey(communityCode, 'TicketWordPlural');

  return {
    value,
    ticketWord: translate.instant(ticketWordKey),
  };
}
